import { ArrowRight, Construction } from 'lucide-react';

interface ComingSoonProps {
  title: string;
  description: string;
  fallbackHref: string;
}

export default function ComingSoon({
  title,
  description,
  fallbackHref,
}: ComingSoonProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <Construction className="h-6 w-6 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground max-w-md">{description}</p>
      <a
        href={fallbackHref}
        className="mt-5 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm hover:opacity-90 transition-opacity"
      >
        Open in classic UI
        <ArrowRight className="h-4 w-4" />
      </a>
    </div>
  );
}
